import React from 'react';

import Box from '@material-ui/core/Box';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {
  ErrorRounded,
  InfoRounded,
} from '@material-ui/icons';
import CheckCircleRounded from '@material-ui/icons/CheckCircleRounded';

import styles, {bannerBoxStyles} from './style';

const useStyles = makeStyles(styles);

const BannerContainer = withStyles(bannerBoxStyles)(Box);


/**
 * AlertBanner Component
 * @param {Object} props
 * @param {?string} props.className
 * @param {?Object} props.style
 * @param {string} props.alertType 'info' || 'error' || 'warning' || 'success'
 * @param {string} props.message banner message to show
 * @return {ReactElement}
 */
function AlertBanner(props) {
  const {alertType, className, message, style} = props;

  const classes = useStyles();

  let alertTypeClass = classes.infoBanner;
  let AlertIcon = ErrorRounded;
  switch (alertType) {
    case 'info':
      AlertIcon = InfoRounded;
      alertTypeClass = classes.infoBanner;
      break;
    case 'warning':
      alertTypeClass = classes.warningBanner;
      AlertIcon = ErrorRounded;
      break;
    case 'error':
      alertTypeClass = classes.errorBanner;
      AlertIcon = ErrorRounded;
      break;
    case 'success':
      alertTypeClass = classes.successBanner;
      AlertIcon = CheckCircleRounded;
      break;
    default:
      break;
  }

  let containerClassName = alertTypeClass;
  if (className) containerClassName += className;

  // do not render empty banners
  if (!message) {
    return null;
  }

  return (
    <BannerContainer
      data-testid={`alert-${message}`}
      aria-label={message}
      className={containerClassName}
      style={style}
    >
      <AlertIcon
        className={classes.bannerIcon+` bannerIcon`}
        aria-label={alertType}
      />
      {message}
    </BannerContainer>

  );
}

export default AlertBanner;
